import { IframeAuthenticationModule } from 'src/app/iframe-authentication/iframe-authentication.module';

export const authModules = [IframeAuthenticationModule];
